enum GeometryType {
  CONTOUR = 'CONTOUR',
  SURFACE = 'SURFACE',
  MESH = 'MESH',
}

export default GeometryType;
